var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14L8 11M11 14C12.3968 13.4687 13.7369 12.7987 15 12M11 14V19C11 19 14.03 18.45 15 17C16.08 15.38 15 12 15 12M8 11C8.53214 9.61943 9.2022 8.29607 10 7.05C11.1652 5.18699 12.7876 3.65305 14.713 2.5941C16.6384 1.53514 18.8027 0.986375 21 1C21 3.72 20.22 8.5 15 12M8 11H3C3 11 3.55 7.97 5 7C6.62 5.92 10 7 10 7M3.5 15.5C2 16.76 1.5 20.5 1.5 20.5C1.5 20.5 5.24 20 6.5 18.5C7.21 17.66 7.2 16.37 6.41 15.59C6.02131 15.219 5.50929 15.0046 4.97223 14.988C4.43516 14.9714 3.91088 15.1537 3.5 15.5Z",
    stroke: "#F9F6F0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.7e9297b9d57aee1e29fe1cd4d9eae6f5.svg";
export { ForwardRef as ReactComponent };